


































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import PageContentWrapper from '@shared/layouts/wrappers/page/page-content-wrapper.vue';
import SidebarPageContentWrapper from '@shared/layouts/wrappers/page/sidebar-page-content-wrapper.vue';
import DrawerContentWrapper from '@shared/layouts/wrappers/drawer-content-wrapper.vue';
import ModalContentWrapper from '@shared/layouts/wrappers/modal-content-wrapper.vue';
import ContainerContentWrapper from './container-content-wrapper.vue';

@Component({
  name: 'bpc-content-wrapper',
  components: {
    'bpc-page-content-wrapper': PageContentWrapper,
    'bpc-sidebar-page-content-wrapper': SidebarPageContentWrapper,
    'bpc-container-content-wrapper': ContainerContentWrapper,
    'bpc-drawer-content-wrapper': DrawerContentWrapper,
    'bpc-modal-content-wrapper': ModalContentWrapper,
  },
})
export default class ContentWrapper extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: String, default: 'page' }) readonly displayMode: string;
  @Prop({ type: String, default: '' }) readonly componentId: string;
  @Prop({ type: String, default: '' }) readonly bodyClass: string;
  @Prop([Object, Array]) readonly contentWrapperAttributes: object | string[];

  // DATA
  // LIFECYCLE
  // created() { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  // COMPUTED

  get contentWrapper() {
    return `bpc-${this.displayMode}-content-wrapper`;
  }

  // METHODS
  // WATCHERS
}
